"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateSlug = void 0;
const validateSlug = (pathname, expectedSlug, expectedPosition) => {
    const slugs = pathname.split("/");
    if (Array.isArray(expectedSlug)) {
        for (const slug of expectedSlug) {
            if (!(slugs[expectedPosition].toLowerCase() === slug)) {
                return false;
            }
        }
        return true;
    }
    return slugs[expectedPosition].toLowerCase() === expectedSlug;
};
exports.validateSlug = validateSlug;
//# sourceMappingURL=validateSlug.js.map